// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { headingsFontConfig } from "@pacific/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@pacific/XDL/Utilities";
import { css } from "styled-components";

export interface CartSummarySharedStyles {
    container?: GridContainerProps;
    emptyGridItem?: GridItemProps;
    labelGridItem?: GridItemProps;
    valueGridItem?: GridItemProps;
    titleGridItem?: GridItemProps;
    titleText?: TypographyProps;
    dividerGridItem?: GridItemProps;
    totalLabel?: TypographyProps;
    totalValue?: TypographyProps;
    label?: TypographyProps;
    value?: TypographyProps;
}

export const sharedTextStyles: TypographyProps = {
    variant: "h5",
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};

export const floatOnPrint = css`
    &&&& {
        @media print {
            float: right;
        }
    }
`;

const cartSummarySharedStyles: CartSummarySharedStyles = {
    container: {
        gap: 0,
    },
    labelGridItem: { width: 6 },
    valueGridItem: { width: 6 },
    titleGridItem: {
        width: 12,
    },
    titleText: {
        variant: "h4",
        as: "p",
        css: css`
            margin-bottom: 0;
        `,
    },
    dividerGridItem: {
        width: 12,
        css: css`
            border-top: 1px solid ${color("common.border")};
            &&& {
                margin: 16px 0;
            }
        `,
    },
    totalLabel: {
        variant: "h4",
        as: "p",
        css: css`
            margin-bottom: 0;
            @media print {
                white-space: nowrap;
            }
        `,
    },
    totalValue: {
        variant: "h4",
        as: "p",
        css: css`
            margin-bottom: 0;
            margin-left: auto;
            ${floatOnPrint}
        `,
    },
    emptyGridItem: {
        width: 12,
        css: css`
            &&& {
                margin: 16px 0 0;
            }
        `,
    },
    label: {
        ...sharedTextStyles,
    },
    value: {
        ...mergeWithCss(sharedTextStyles, {
            css: css`
                margin-left: auto;
                ${floatOnPrint}
            `,
        }),
    },
};

export default cartSummarySharedStyles;
